// extracted by mini-css-extract-plugin
export var card = "_sb-0";